import moment from 'moment-timezone'

import { fillLevelThresholds } from '@/components/asset-types/dynamic-bin/dynamicBinSettings'
import { sbbFillLevelThresholds } from '@/components/asset-types/sbb-bin/sbbBinSettings'
import { measurementHelper, languageHelper } from '@/utils'

function sbbFillLevel(asset) {
    if (asset?.asset_details?.sensor_data?.distance?.value !== undefined) {
        return measurementHelper.convertToSbbBinLevel(
            asset.asset_details.sensor_data.distance.value
        )
    }
    return undefined
}

const sbbFillLvlThresholds = sbbFillLevelThresholds

export default {
    methods: {
        getCustomerData(asset) {
            const schema = this.$store.getters['tracker/assetTypesById']?.[
                asset?.asset_details?.asset_type
            ]?.additional_data_schema?.properties

            return Object.keys(schema ?? {})
                .filter(key => schema[key].display !== false)
                .map(key => {
                    const value =
                        asset?.asset_details?.additional_data?.[key] ??
                        schema[key].default
                    return {
                        key,
                        type: schema[key].type,
                        format: schema[key].format,
                        label:
                            schema[key].label?.[this.$i18n.locale] ||
                            schema[key].label?.[
                                languageHelper.defaultLanguage
                            ] ||
                            key,
                        value:
                            schema[key].format === 'date'
                                ? moment(value).format('DD.MM.YYYY')
                                : value,
                    }
                })
        },
        trackerAssetTypePicture(identifier) {
            return this.$store.state.tracker?.assetTypes?.find(
                assetType =>
                    assetType.identifier.localeCompare(identifier) === 0
            )?.picture?.url
        },
        getError(asset) {
            let fillLevel
            switch (asset?.asset_details?.asset_type_type) {
                case 'dynamic-bin':
                case 'dynamic-bin-collection':
                    if (
                        asset?.asset_details?.sensor_data?.fill_level?.value >=
                        fillLevelThresholds.high
                    ) {
                        return 'error-generic'
                    } else if (
                        asset?.asset_details?.sensor_data?.fill_level?.value >
                        fillLevelThresholds.low
                    ) {
                        return 'warning-generic'
                    } // eslint-disable-next-line no-fallthrough
                case 'sbb-bin':
                    fillLevel = sbbFillLevel(asset)
                    if (
                        asset?.asset_details?.asset_type_identifier ===
                        'sbb-bin-paper'
                    ) {
                        if (fillLevel >= sbbFillLvlThresholds.paper.high) {
                            return 'error-generic'
                        } else if (fillLevel > sbbFillLvlThresholds.paper.low) {
                            return 'warning-generic'
                        }
                    } else {
                        if (fillLevel >= sbbFillLvlThresholds.normal.high) {
                            return 'error-generic'
                        } else if (
                            fillLevel > sbbFillLvlThresholds.normal.low
                        ) {
                            return 'warning-generic'
                        }
                    } // eslint-disable-next-line no-fallthrough
                default:
                    if (asset?.asset_details?.alert) {
                        return 'warning-generic'
                    }
                    return null
            }
        },
    },
}
